import type { ShortTermGoalsProps } from './division-form-stg.interface';
import type { FC } from 'react';

import { FieldArray } from 'formik';
import React from 'react';

import DivisionFormStgItem from './division-form-stg-item';
import { usePermissions } from '../../../../contexts/permissions.context';
import * as utils from '../../../../shared/utils';
import { vocabulary } from '../../../../vocabulary/german';
import { CreateButton } from '../../../buttons/create-button/create-button';

export const DivisionFormStg: FC<ShortTermGoalsProps> = ({
  values,
  midTermGoal,
  yearId,
  currentYearFrozen = false,
}: ShortTermGoalsProps) => {
  const matrix = usePermissions();
  const onAddShortTermGoal = (shortTermGoalsHelper) => () => {
    shortTermGoalsHelper.push({
      MidtermGoalId: midTermGoal.id,
      title: '',
      outcome: '',
      Actions: [],
      reason: '',
      isShowReason: false,
      YearId: yearId,
    });
  };

  const permissionsCanChange = utils.notChangeGoal();
  return (
    <FieldArray
      name={'ShortTermGoals'}
      render={(shortTermGoalsHelper) => {
        const hasGoals =
          values.ShortTermGoals && values.ShortTermGoals.length > 0;

        return (
          <>
            {hasGoals ? (
              <>
                {values.ShortTermGoals.map(
                  (shortTermGoal, shortTermGoalIndex) =>
                    shortTermGoal.MidtermGoalId === midTermGoal.id && (
                      <DivisionFormStgItem
                        key={shortTermGoalIndex}
                        shortTermGoal={shortTermGoal}
                        shortTermGoalIndex={shortTermGoalIndex}
                        shortTermGoalsHelper={shortTermGoalsHelper}
                        currentYearFrozen={currentYearFrozen}
                      />
                    ),
                )}
                {(currentYearFrozen
                  ? matrix.permissions.freezeAddFieldsInside === true
                  : matrix.permissions.addFieldsInside === true) &&
                  !permissionsCanChange && (
                    <CreateButton
                      text={vocabulary.buttons.addShortTermGoal}
                      onClick={onAddShortTermGoal(shortTermGoalsHelper)}
                    />
                  )}
              </>
            ) : (
              <>
                {(currentYearFrozen
                  ? matrix.permissions.freezeAddFieldsInside === true
                  : matrix.permissions.addFieldsInside === true) &&
                  !permissionsCanChange && (
                    <CreateButton
                      text={vocabulary.buttons.addShortTermGoal}
                      onClick={onAddShortTermGoal(shortTermGoalsHelper)}
                    />
                  )}
              </>
            )}
          </>
        );
      }}
    />
  );
};
